import { AllCampaignBillingResponse } from '../../api-models';
import { CampaignBillingSummary } from '../../types/campaigns.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class GetCampaignBillingSummary extends BaseAdapter<AllCampaignBillingResponse[]> implements AdapterInterface {
  rawResponse: AllCampaignBillingResponse[];

  async adaptResponse(): Promise<CampaignBillingSummary[]> {
    await this.fetchApiResponse('/api/campaign-billing-summary', HTTPMethod.Get);
    return this.displayResponse();
  }

  async displayResponse(): Promise<CampaignBillingSummary[]> {
    return this.rawResponse.map((item: AllCampaignBillingResponse) => ({
      organisationName: item.organisation_display_name,
      isCampaignEnabled: item.is_campaign_enabled,
      sms: {
        allowance: item.sms_amount,
        lastUpdated: item.sms_last_updated_date,
      },
      printAndPost: {
        allowance: item.print_and_post_amount,
        lastUpdated: item.print_and_post_last_updated_date,
      },
    }));
  }
}
